module.exports = __webpack_public_path__ + "img/neotaglogo_text.5b7836b2.svg";